import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

import { useTheme } from '@mui/system';
import { useGetUserData } from '@hooks/useGetUserData';

interface DealSortSelectProps {
  value: string;
  onChange: (val: string) => void;
  showPopular?: boolean;
}

const DealSortSelect = ({
  value,
  onChange,
  showPopular = true
}: DealSortSelectProps) => {
  const theme = useTheme();
  const { data: user } = useGetUserData();
  const mostPopularOptionStr = user?.hasVerifiedEmail
    ? `Most popular deals first`
    : `Most popular deals first (${
        user ? 'verify email to activate' : 'users only'
      })`;
  const mostPopularOptionDisabled = !user?.hasVerifiedEmail;
  return (
    <FormControl fullWidth variant="outlined" size="small">
      <InputLabel
        sx={{
          backgroundColor: theme.palette.background.paper,
          padding: '0 6px'
        }}
        id="deal-sort-select-label"
      >
        Sort By
      </InputLabel>
      <Select
        value={value}
        fullWidth
        onChange={(event) => {
          onChange(event.target.value as string);
        }}
        labelId="deal-sort-select-label" // Correct labelId
        aria-labelledby="deal-sort-select-label"
      >
        <MenuItem value="dateActive">Newest deals first</MenuItem>
        {showPopular ? (
          <MenuItem value="mostPopular" disabled={mostPopularOptionDisabled}>
            {mostPopularOptionStr}
          </MenuItem>
        ) : null}
        <MenuItem value="finalPrice">Lowest priced deals first</MenuItem>
        <MenuItem value="highestPrice">Highest priced deals first</MenuItem>
        <MenuItem value="highestDiscount">Most discounted deals first</MenuItem>
      </Select>
    </FormControl>
  );
};

export default DealSortSelect;
